import React from 'react';
import { AppHead } from '.';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { axius, func } from 'helpers';

import * as dataAct from 'store/data/_dataActions';
import Loading from './Loading';

import Header from 'partials/Header';
import Footer from 'partials/Footer';

const Layout = props => {

    const { _data: { forex, countries } } = props;

    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        setTimeout(() => {
            window.init && window.init();
        }, 200);

        props.setSetSettings('lang', func.getCookie('lang') || navigator.language.split(/[-_]/)[0]);
        func.setCookie('defCountry', func.getCookie('country') || 'GH');

        if (forex.length > 0 && countries.length > 0) {
            setLoading(false);
        }

        Promise.all([
            axius.get('settings'),
            axius.get('settings/countries'),
        ]).then(res => {
            setLoading(false);
            if (res[0].status === 200) {
                props.setSetSettings('kyc', res[0].data.kyc);
                props.setSetSettings('fees', res[0].data.fees);
                props.setSetSettings('forex', res[0].data.forex);
                props.setSetSettings('settings', res[0].data);
                props.setSetSettings('countries', res[1].data);
            }
        });
    }, []);

    return (
        <React.Fragment>
            <IntlProvider locale="en" defaultLocale="en">
                <AppHead {...props.Head || {}} />
                <Header {...props} />

                <div style={{ minHeight: '84vh' }}>
                    {loading ? <Loading /> : props.children}
                </div>

                <Footer {...props} />
            </IntlProvider>
        </React.Fragment>
    );
}

const mapStateToProps = (state) => ({
    _data: state.data,
});

const mapDispatchToProps = (dispatch) => ({
    setSetSettings: (key, value) => {
        dispatch(dataAct.setSetSettings(key, value));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);